import React from 'react';
import { ListItem, ListItemText, ListItemSecondaryAction, Button, Avatar, Icon, Typography } from '@material-ui/core';
import { get, last } from 'global/lib/lodash';
import useStyles from './TaskList.styles';
import { useScreen } from 'global/styles';
import moment from 'moment';

export default (props) => {
  const { isMobile } = useScreen();
  const item = props.itemOverride || props.item;

  const classes = useStyles({ isMobile });

  const clickDownload = (e) => {
    const media = last(get(item, 'media', []));
    const url = get(media, 'full7DayUrl', get(media, 'fullUrl'));
    if (url) {
      window.open(url, '_blank');
    }
  };

  const content = {
    label: moment(get(item, 'createdAt')).format('dddd, MMMM DD, YYYY'),
    from: get(item, 'from.name', ''),
    to: get(item, 'to', ''),
  };
  content.icon = <Icon>description</Icon>;
  const dayDiff = Math.abs(moment(content.agingDate).diff(moment(), 'days'));
  content.timerClassName = dayDiff > 21 ? classes.redIcon : dayDiff > 7 ? classes.orangeIcon : classes.greyIcon;

  return (
    <ListItem component={'div'} key={item.id}>
      <Avatar className={classes.avatar}>{content.icon}</Avatar>
      <ListItemText
        classes={{ primary: classes.listItemHeader }}
        primary={content.label}
        secondaryTypographyProps={{ component: 'div' }}
        secondary={
          <>
            <Typography classes={{ root: classes.datesText }}>{`From: ${content.from}`}</Typography>
            <Typography classes={{ root: classes.datesText }}>{`To: ${content.to}`}</Typography>
          </>
        }
      />
      <ListItemSecondaryAction>
        <Button onClick={clickDownload} classes={{ root: classes.msgBtnRoot, label: classes.msgBtnLabel }}>
          <Icon>get_app</Icon>
        </Button>
      </ListItemSecondaryAction>
    </ListItem>
  );
};
